import { createContext, useContext, type ReactNode } from 'react';

export type DashboardTimeRange = '1h' | '6h' | '24h' | '7d' | '30d';

export const DEFAULT_DASHBOARD_TIME_RANGE: DashboardTimeRange = '24h';

const DashboardTimeRangeContext = createContext<DashboardTimeRange>(DEFAULT_DASHBOARD_TIME_RANGE);

export function DashboardTimeRangeProvider({
  timeRange,
  children,
}: {
  timeRange: DashboardTimeRange;
  children: ReactNode;
}) {
  return (
    <DashboardTimeRangeContext.Provider value={timeRange}>
      {children}
    </DashboardTimeRangeContext.Provider>
  );
}

export function useDashboardTimeRange(): DashboardTimeRange {
  return useContext(DashboardTimeRangeContext);
}
